import type { VoidFunctionComponent } from 'react';

import { useDialogContext } from '../../contexts/DialogContext';
import useAsyncStatus from '../../hooks/useAsyncStatus';
import { post } from '../../redux/api';
import Button from '../generic/Button';
import Text from '../generic/Text';

/**
 * Shows a button to trigger backfill SBOM summary data.
 */
export const BackfillSBOMSummaryData: VoidFunctionComponent = () => {
  const requestStatus = useAsyncStatus();
  const { onConfirm } = useDialogContext();

  const onButtonClick = () => {
    onConfirm({
      title: 'Backfill SBOM Summary Data',
      body: (
        <div>
          Are you sure you want to backfill SBOM summary data?
        </div>
      ),
      onConfirm: async () => {
        try {
          requestStatus.onPending();
          await post('/api/organizations/backfill-sbom-summary-data', {});
          requestStatus.onSuccess();
        } catch (e) {
          requestStatus.onError(e as Error);
        }
      },
    });
  };

  return (
    <div className="card">
      <Text.H4>Backfill SBOM Summary Data</Text.H4>
      <Text.Paragraph>
        This will queue a background job that backfills data required for SBOM analysis.
      </Text.Paragraph>
      <Button onClick={onButtonClick}>
        Backfill
      </Button>
    </div>
  );
};

export default BackfillSBOMSummaryData;
